/**
 * RESTRUCTURE gamerounds:
 *
 * Game rounds are saved in a hierarchical order now, ordered by simulationId by default.
 * items: {
 *   [simulationId]: `[
 *     round0,
 *     round1
 *   ]`
 * }
 */

import { mapValues, groupBy } from "lodash-es";

export default {
  name: "restructure gameRounds",
  applyToVersions: "<1.32.0",
  type: "before",
  migrate(data) {
    if (!data?.gameRounds) return data;

    const gameRounds = data.gameRounds.items || {};
    const elements = data.elements.items || {};
    const elementWeights = mapValues(elements, (element) => element.weight);

    // group impulses by simulationId first
    const gameRoundsByGameId = groupBy(gameRounds, "gameId");

    for (const simulationId in gameRoundsByGameId) {
      const sortedRounds = gameRoundsByGameId[simulationId].sort(
        (a, b) => a.order - b.order
      );
      sortedRounds.forEach(cleanRound);
      sortedRounds.forEach((round) => {
        if (!round.played) return;
        // set the total value
        round.totalValue = calculateTotalValue(round, elementWeights);
      });

      gameRoundsByGameId[simulationId] = sortedRounds;
    }

    data.gameRounds.items = gameRoundsByGameId;

    return data;
  }
};

function calculateTotalValue(round, elementWeights) {
  // no elements? value is 0.
  if (Object.keys(round.targetValues || {}).length === 0) return 0;

  const targetValueEntries = Object.entries(round.targetValues || {});
  return (
    targetValueEntries.reduce((sum, [, value]) => sum + value, 0) /
    targetValueEntries.length
  );
}

function cleanRound(round) {
  delete round.id;
  delete round.gameId;
  round.pausedHere = false;
  round.index = round.order;
  round.totalValue = null;

  for (const measureId in round.preventedMeasures) {
    const preventedMeasure = round.preventedMeasures[measureId];
    preventedMeasure.conditionIds = [preventedMeasure.conditionId];
  }
}
